import { useSelectorUserProfiles } from '../../../user-profiles';

export const useWelcomeRoute = () => {
    const {
        isLoading,
        isError,
        error,
        data: userProfilesData
    } = useSelectorUserProfiles();

    return {
        isInitialLoading: isLoading || !userProfilesData && !isError,
        isLoading,
        isError,
        error
    };
};
